module.exports = __webpack_public_path__ + "static/media/help_MisInversiones.b0aa8d7d.png";